module.exports = __webpack_public_path__ + "static/media/Skarner_0.df00b974.jpg";